import React, { useContext, useState } from 'react';
import { style } from 'typestyle';
import MenuDownIcon from 'mdi-react/MenuDownIcon';
import * as communicationStyles from '../office-communication.styles';
import * as surfaceStyles from '../../../core/admin-surface.styles';
import { IsMobileContext } from '../../../core/context/is-mobile';

interface Props {
  readonly label: string;
  readonly count: number;
  /** Finished/sent messages can be folded away; they still start open. */
  readonly collapsible?: boolean;
  readonly children: React.ReactNode;
}

// One status bucket ("Live now", "Scheduled", "Finished") on the Communication tab.
const MessageGroup = ({ label, count, collapsible = false, children }: Props): React.JSX.Element | null => {
  const isMobile = useContext(IsMobileContext);
  // Every bucket starts expanded — collapsing is something the reader chooses.
  const [collapsed, setCollapsed] = useState(false);

  if (count === 0) {
    return null;
  }

  const heading = (
    <>
      <h3 className={style(surfaceStyles.groupTitle)}>{`${label} (${count})`}</h3>
      <div className={style(surfaceStyles.groupRule)} />
    </>
  );

  return (
    <section className={style(surfaceStyles.group)}>
      {collapsible ? (
        <button
          type="button"
          className={style(communicationStyles.groupHeadButton)}
          aria-expanded={!collapsed}
          onClick={(): void => setCollapsed((current) => !current)}
        >
          {heading}
          <span className={style(communicationStyles.caret(collapsed))}>
            <MenuDownIcon size={18} />
          </span>
        </button>
      ) : (
        <div className={style(surfaceStyles.groupHead)}>{heading}</div>
      )}
      {!collapsed && <div className={style(communicationStyles.grid(isMobile))}>{children}</div>}
    </section>
  );
};

export default MessageGroup;
